import * as React from 'react';

import {
  Button,
  FormPageSkeleton,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@klareospace/pharos-lib-web-utils';
import { useTranslation } from 'react-i18next';

import { useTenantDefaultsPage } from '../hooks/use-tenant-defaults-page';

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function TenantDefaultsPage(): React.JSX.Element {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('settings');
  const {
    canWrite,
    currentHandlingUnitTypeId,
    handleCancel,
    handleHandlingUnitTypeChange,
    handleSave,
    handlingUnitTypes,
    isDirty,
    isLoading,
    isPending,
  } = useTenantDefaultsPage();

  if (isLoading) {
    return <FormPageSkeleton sections={[1]} />;
  }

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between py-4">
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium">{t('tenantDefaults.fields.defaultHandlingUnitType.label')}</span>
          <span className="text-muted-foreground text-sm">
            {t('tenantDefaults.fields.defaultHandlingUnitType.description')}
          </span>
        </div>
        <div className="w-64 shrink-0">
          <Select disabled={!canWrite} onValueChange={handleHandlingUnitTypeChange} value={currentHandlingUnitTypeId}>
            <SelectTrigger>
              <SelectValue placeholder={t('tenantDefaults.fields.defaultHandlingUnitType.placeholder')} />
            </SelectTrigger>
            <SelectContent>
              {handlingUnitTypes.map((hut) => (
                <SelectItem key={hut.id} value={hut.id}>
                  {hut.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {isDirty && (
        <>
          <hr className="mt-4" />
          <div className="flex justify-start gap-2 pt-4">
            <Button disabled={isPending} onClick={handleSave}>
              {tCommon('actions.saveChanges')}
            </Button>
            <Button onClick={handleCancel} variant="outline">
              {tCommon('actions.cancel')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
